import PatientLoginScene from './PatientLoginScene'
export default PatientLoginScene
